/* eslint-disable better-mutation/no-mutation */

import { createSlice } from '@reduxjs/toolkit';
import { isNextJs, isServer } from 'tradera/utils/nextjs';

type RequestState = {
    cookies: NodeJS.Dict<string> | null;
    isBot: boolean;
    location: string | null;
    userAgent: string | null;
    request?: unknown;
    response?: unknown;
    requestId: number;
};

export const initialState: RequestState = {
    cookies: null,
    isBot: false,
    location: null,
    userAgent: null,
    requestId: 0
};

const slice = createSlice({
    name: 'request',
    initialState,
    reducers: {
        setCookies: (state, { payload }) => {
            state.cookies = payload;
        },
        setIsBot: (state, { payload }) => {
            state.isBot = payload;
        },
        setLocation: (state, { payload }) => {
            state.location = payload;
        },
        setUserAgent: (state, { payload }) => {
            state.userAgent = payload;
        },
        setRequestAndResponse: (state, { payload }) => {
            state.request = payload.request;
            state.response = payload.response;
        },
        setRequestId: (state) => {
            if (isNextJs && !isServer) {
                throw new Error(
                    'setRequestId should only be called on the server'
                );
            }
            state.requestId = Math.random();
        }
    }
});

export const {
    setCookies,
    setIsBot,
    setLocation,
    setUserAgent,
    setRequestAndResponse,
    setRequestId
} = slice.actions;
export const reducer = slice.reducer;
